// src/components/Layout/LogoutButton.js
import React from 'react';
import { Button, Tooltip, ActionIcon } from '@mantine/core'; // Added ActionIcon
import { IconLogout } from '@tabler/icons-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function LogoutButton({ iconOnly = false }) { // Added iconOnly prop
  const { signout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signout();
      navigate('/login');
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  if (iconOnly) {
    return (
      <Tooltip label="Logout" position="bottom" withArrow>
        <ActionIcon
          variant="light" // Consistent with button variant
          color="blue"    // Consistent with button color (user's tweak)
          size="lg"       // ActionIcon 'lg' is approx 34-36px, Button 'sm' is 30px, 'md' is 36px. Let's use 'lg' for good tap target.
          onClick={handleLogout}
          aria-label="Logout"
        >
          <IconLogout size="1.25rem" />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Tooltip label="Logout" position="bottom" withArrow>
      <Button
        variant="light" // User's preferred variant
        color="blue"    // User's preferred color
        size="sm"       // User's preferred size
        onClick={handleLogout}
        leftSection={<IconLogout size="1.125rem" />}
      >
        Logout
      </Button>
    </Tooltip>
  );
}

export default LogoutButton;